/*
    模块组件
    ChenYN

    说明
    用户列表

    版本
    1.0

    传参
        name Sting : 当前页面的name(同路由)
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <User></User>
*/

<template>
    <div class="data_content">           
        <div class="data_row">
            <div class="data_row_l" @click.stop="goState({name:'minedetail',query: {userId:userData.user_id,time:new Date().getTime()}})">
                <img class="data_head" :src="userData.user_avatar" v-if="userData.user_avatar"/>
                <img class="data_head" src="@/assets/images/common/icon_avatar_boy.png" v-else/>
                <img class="data_dress" :src="userData.user_avatar_frame.avatar_frame" v-if="userData.user_avatar_frame"/>
                <!-- <img class="data_dress" src="@/assets/images/head_dress/head_dress.png" /> -->
            </div>

            <div class="data_row_r">
                <div>
                    <span class="name van-ellipsis">
                        {{userData.nickname}}
                    </span>
                    <!-- <div class="icon_vip">
                        <img :src="userData.vip_badge"/>
                    </div> -->
                </div>
                <div class="txt van-ellipsis">{{userData.introduction||'该用户没有介绍哦~'}}</div>
            </div>
        </div>
        <div class="data_row_add" v-if="btnType == 'attention'">
            <div class="data_row_invite" @click="attention" v-if="!userData.is_atttention">+关注</div>
            <div class="data_row_invite cancel" @click="cancelattention" v-else>已关注</div>
        </div>                
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import router from "@/router"

export default defineComponent({
    name: 'User',
    props: {
        userData: {
            type: Object,
        },
        btnType: {
            type: String,
        },
        func: {
            type: Function,
        },
        cancelfunc: {
            type: Function,
        }        
    },
    setup(props) {
        const state = reactive({
            img:'/src/assets/images/mine/attention_head.png',
        });
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            attention: () => {props.func(props.userData.user_id)},
            cancelattention: () => {props.cancelfunc(props.userData.user_id)},
        }; //需要对外暴露的方法

        onMounted(() => {
        });

        

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./User.less";
</style>